// extracted by mini-css-extract-plugin
export var wrapper = "GearGatsbyImage-module--wrapper--cBF9b";